const all = [];
const admin = { groups: all, admin: true, adminOnly: true };
export default {
    title: "Segnalazioni",
    icon: "mdi-clipboard-alert-outline",
    ...admin,
    submenu: [
        { title: "Nuova segnalazione", route: { name: "SgiNuova" }, ...admin },
        { title: "Le mie segnalazioni", route: { name: "SgiMie" }, ...admin },
        { title: "Le mie azioni", route: { name: "SgiAttivita" }, ...admin },
        { title: "Gestione segnalazioni", route: { name: "SgiGestione" }, ...admin },
        { title: "Cruscotto SGI", route: { name: "SgiCruscotto" }, ...admin },
        { title: "Comunicazioni", route: { name: "SgiComunicazioni" }, ...admin },
    ],
};
